import { Experiment as MarvelExperiment, Variant as MarvelVariant } from '@marvelapp/react-ab-test';
import useIntl from '/imports/core/api/useIntl';
import { COLOR_PREVIEW_TEMPLATES_ACTIVE_LOCALE } from '/imports/onboarding/api/constants';

export const RenderResumeTemplateColorV2 = ({ children }) => {
  const { locale } = useIntl();

  if (!COLOR_PREVIEW_TEMPLATES_ACTIVE_LOCALE.includes(locale)) {
    return children;
  }

  return (
    <MarvelExperiment name="exp_resume_template_color_v2">
      <MarvelVariant name="control">{children}</MarvelVariant>
      <MarvelVariant name="with_template_color">{children}</MarvelVariant>
    </MarvelExperiment>
  );
};
